<template>
	<v-dialog
		v-model="open"
		max-width="700"
		@click:outside="$emit('close')"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<v-card :tile="$vuetify.breakpoint.xs">
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white">メッセージ詳細</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-btn icon dark @click="$emit('close')" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<v-sheet elevation="0" class="pa-2">
				<v-sheet elevation="0" class="mt-4">
					<table width="100%" class="show-dialog-table">
						<tbody>
							<tr>
								<th width="30%" class="font-weight-bold">送信者</th>
								<td v-if="item.user && item.user.full_name" width="70%">{{ item.user.full_name }}</td>
								<td v-else width="70%">システム</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">タイトル</th>
								<td width="70%">{{ item.title }}</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">内容</th>
								<td width="70%" class="pre-wrap">{{ item.content }}</td>
							</tr>
							<!-- <tr v-if="item.requirement_type">
								<th width="30%" class="font-weight-bold">依頼名</th>
								<td width="70%">{{ item.requirement_type.name }}</td>
							</tr> -->
							<tr v-if="item.requirement">
								<th width="30%" class="font-weight-bold">依頼</th>
								<td width="70%">
									{{
										item.requirement
											? item.requirement_type.name +
											  (item.requirement.subtitle != null ? "：" + item.requirement.subtitle : "")
											: ""
									}}
									<v-icon
										@click="showRequirementDialog(item.requirement.id, 0)"
										class="pointer blue--text"
									>
										mdi-link
									</v-icon>
								</td>
							</tr>
							<tr v-if="item.matter">
								<th width="30%" class="font-weight-bold">案件</th>
								<td width="70%">
									<v-btn
										small
										outlined
										class="ma-1 btn-no-transform"
										color="primary"
										@click="matterDialog = true"
									>
										{{ item.matter ? item.matter.name : "" }}
									</v-btn>
								</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">添付ファイル</th>
								<td width="70%">
									<template v-if="item.files_with_url && item.files_with_url.length">
										<v-btn
											small
											outlined
											class="ma-1 btn-no-transform"
											color="primary"
											v-for="file in item.files_with_url"
											:key="file.id"
											:href="file.url"
											target="_blank"
										>
											<v-icon class="mr-2">mdi-download</v-icon>
											{{ file.name }}
										</v-btn>
									</template>
									<template v-else>なし</template>
								</td>
							</tr>
							<tr v-if="item.url">
								<th width="30%" class="font-weight-bold">リンク</th>
								<td width="70%"><v-btn @click="goToLink">リンク先へ</v-btn></td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">送信時刻</th>
								<td width="70%">{{ item.datetime_ja_2row }}</td>
							</tr>
						</tbody>
					</table>
				</v-sheet>
			</v-sheet>
			<v-card-actions>
				<v-row no-gutters>
					<v-col cols="8" />
					<v-col cols="4">
						<v-row no-gutters justify="end">
							<v-btn color="grey darken-1" text @click="$emit('close')"> 閉じる </v-btn>
						</v-row>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-card>
		<RequirementShowDialog ref="requirementShow" />
		<MatterShowDialog
			v-if="matterDialog"
			:id="item.matter_id"
			:requiredFetch="true"
			@close="matterDialog = false"
		/>
	</v-dialog>
</template>

<script>
import TemplateDeleteDialog from "../../shared/TemplateDeleteDialog.vue"
import RequirementShowDialog from "../../requirement/components/RequirementInfoDialog.vue"
import MatterShowDialog from "../../matter/components/MatterShowDialog.vue"

export default {
	props: {
		item: {
			type: Object,
			required: true,
			default: () => {},
		},
		text: Boolean,
	},
	components: {
		TemplateDeleteDialog,
		RequirementShowDialog,
		MatterShowDialog,
	},
	data() {
		return {
			open: true,
			name: "",
			matterDialog: false,
		}
	},
	mounted() {
		console.log(this.item)
	},
	methods: {
		showRequirementDialog(id, index) {
			this.$refs.requirementShow.openDialog(id, index)
		},
		goToLink() {
			this.$router.push({ path: this.item.url })
		},
	},
	watch: {
		itemData(newValue, _) {
			this.item = newValue
		},
		deep: true,
	},
}
</script>

<style lang="scss" scoped>
td {
	img {
		max-height: 150px;
		max-width: 100%;
		display: block;
	}
}
.pointer {
	cursor: pointer;
}
</style>
